class CSRF {
  get csrfToken () {
    return document.querySelector('meta[name=csrf-token]')?.content
  }

  get csrfParam () {
    return document.querySelector('meta[name=csrf-param]')?.content
  }

  get headers () {
    return { [this.header]: this.csrfToken }
  }

  get data () {
    return { [this.csrfParam]: this.csrfToken }
  }

  get header () {
    return self.constructor.HEADER
  }

  static HEADER = 'X-CSRF-Token'

  static get instance () {
    if (!this._instance) this._instance = new this()
    return this._instance
  }
}

export default CSRF.instance
